export default __webpack_public_path__ + "images/default-no-image.svg";